"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpinnerWithCaption = void 0;
const react_1 = __importDefault(require("react"));
const tds_1 = require("@guided-methods/tds");
require("./styles/spinnerWithCaption.scss");
const SpinnerWithCaption = (props) => (react_1.default.createElement("div", { className: "spinnerWithCaption" },
    react_1.default.createElement("div", { className: "spinnerWithCaption__spinner" },
        react_1.default.createElement(tds_1.Spinner, { size: "lg" }),
        react_1.default.createElement("span", { className: "ps-1" }, props.caption))));
exports.SpinnerWithCaption = SpinnerWithCaption;
